<template>
  <div>
    <p class="py-6">
      Control how many
      <strong>appointments</strong>
      or
      <strong>handling units</strong>
      (e.g. pallets) can be scheduled at your warehouse, docks, or by load type.
    </p>
    <div
      class="border border-radius pa-5 d-flex justify-space-between align-center font-weight-bold cursor-pointer mb-3"
      @click="
        $router.push({
          name: 'warehouses.details.settings',
          query: { active: 'limits', limitType: 'Appointment' }
        })
      ">
      <span>Appointment Limiter</span>
      <span class="text-uppercase">
        Manage
        <v-icon icon="mdi-arrow-right" />
      </span>
    </div>
    <div
      :class="[
        'border border-radius pa-5 d-flex justify-space-between align-center font-weight-bold',
        areHandlingUnitsEnabled ? 'cursor-pointer' : 'cursor-not-allowed opacity-50'
      ]"
      role="button"
      :aria-disabled="!areHandlingUnitsEnabled"
      @click="onClickHandlingUnits">
      <div>
        Handling Units Limiter
        <span class="font-weight-light font-size-small d-block">
          {{ warehouseSettings.handlingUnitsLabel }}
        </span>
      </div>
      <span class="text-uppercase">
        Manage
        <v-icon icon="mdi-arrow-right" />
      </span>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  warehouse: {
    type: Object,
    required: true
  }
});
const warehouseSettings = props.warehouse.settings || {};
// TODO add realtime update
const areHandlingUnitsEnabled = Boolean(
  warehouseSettings.includeHandlingUnitsFieldOnAppointmentForms
);
</script>

<style scoped lang="scss"></style>
